'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { usageTrackerActions } from 'usage-tracker-redux';
import { EventTypes } from '../../lib/usage/constants';
var track = usageTrackerActions.track;
export default (function () {
  return function (WrappedComponent) {
    var _class, _temp;

    return connect(undefined, {
      track: track
    })((_temp = _class = /*#__PURE__*/function (_Component) {
      _inherits(HighOrderWithUsageTracking, _Component);

      function HighOrderWithUsageTracking() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, HighOrderWithUsageTracking);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HighOrderWithUsageTracking)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _this.trackClickedLink = function (screen, value) {
          _this.props.track(EventTypes.CLICKED_LINK, {
            screen: screen,
            value_str: value
          });
        };

        _this.trackPageview = function (screen) {
          _this.props.track(EventTypes.PAGEVIEW, {
            screen: screen
          });
        };

        _this.trackPurchasedGood = function (screen, value, valueStr) {
          var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

          _this.props.track(EventTypes.PURCHASED_GOOD, Object.assign({
            screen: screen,
            value: value,
            value_str: valueStr
          }, extra));
        };

        _this.trackAdjustedFilter = function (screen, filterType, value) {
          _this.props.track(EventTypes.ADJUSTED_FILTER, {
            screen: screen,
            filter_type: filterType,
            value_str: value
          });
        };

        return _this;
      }

      _createClass(HighOrderWithUsageTracking, [{
        key: "render",
        value: function render() {
          return React.createElement(WrappedComponent, Object.assign({}, this.props, {
            trackAdjustedFilter: this.trackAdjustedFilter,
            trackClickedLink: this.trackClickedLink,
            trackPageview: this.trackPageview,
            trackPurchasedGood: this.trackPurchasedGood
          }));
        }
      }]);

      return HighOrderWithUsageTracking;
    }(Component), _class.propTypes = {
      track: PropTypes.func.isRequired
    }, _temp));
  };
});